export default function PauseIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M17.2757 5.47001C17.7109 5.63035 18 6.04498 18 6.50878L18 17.4913C18 17.9551 17.7109 18.3697 17.2757 18.53C16.4523 18.8334 15.5477 18.8334 14.7243 18.53C14.2891 18.3697 14 17.9551 14 17.4913L14 6.50878C14 6.04498 14.2891 5.63035 14.7243 5.47001C15.5477 5.16665 16.4523 5.16665 17.2757 5.47001Z"
                fill="currentColor"
            />
            <path
                d="M9.27568 5.47001C9.71088 5.63035 10 6.04498 10 6.50878L10 17.4913C10 17.9551 9.71088 18.3697 9.27568 18.53C8.45228 18.8334 7.54772 18.8334 6.72432 18.53C6.28912 18.3697 6 17.9551 6 17.4913L6 6.50878C6 6.04498 6.28912 5.63035 6.72432 5.47001C7.54772 5.16665 8.45228 5.16665 9.27568 5.47001Z"
                fill="currentColor"
            />
        </svg>
    )
}
